<template>
  <div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
    <Navigator/>
    <SliderBanner :slider="slider"/>
    <Step :stepData="stepInfo" style="background: #F4F7FF; padding-bottom: 40px"/>
    <FuncShow :funInfo="funInfo" style="background: #F4F7FF; padding-top: 0px;">
      <div slot="title" class="func-title2">后台设置</div>
    </FuncShow>
    <Footer/>
    <ContactFloat/>
  </div>
</template>

<script>
import Navigator from '../widgets/navigator'
import Footer from '../widgets/footer'
import SliderBanner from '../widgets/SliderBanner'
import FuncShow from '../widgets/func-show'
import Step from '../widgets/Step'
import ContactFloat from '../widgets/contact-float.vue'
export default {
  components: {
    Navigator,
    FuncShow,
    ContactFloat,
    SliderBanner,
    Step,
    Footer
  },
  data() {
    return {
      stepInfo: {
        title: '选品首页',
        subTitle: '通过PC网站 小程序服务抖客 达人 轻松赚两份佣金',
        stepList: [
          {
            normalImg: '',
            choiceImg: '',
            stepTitle: '',
            showImg: require('@/assets/images/index/team-selection/show1.png')
          }
        ]
      },
      slider: {
        image: require('@/assets/images/index/team-selection/phone.png'),
        title: '团长选品',
        desc: "抖音快手团长选品平台，一键同步抖音选品活动产品，通过PC网站 小程序服务抖客 达人 轻松赚两份佣金"
      },
      funInfo: {
        title: '',
        title2: '后台设置',
        list: [
          {
            title: '团长商品列表',
            img: require('@/assets/images/index/team-selection/img2.png'),
            text: '抖音快手团长选品平台，可以一键同步抖音选品活动产品'
          },
          {
            title: '团长订单',
            img: require('@/assets/images/index/team-selection/img3.png'),
            text: '可以在后台查看团长的订单情况'
          },
          {
            title: '达人管理',
            img: require('@/assets/images/index/team-selection/img4.png'),
            text: '可以看到快手、抖音的达人信息'
          },
          {
            title: '个性化首页',
            img: require('@/assets/images/index/team-selection/img5.png'),
            text: '后台可以个性化设计pc端选品平台，打造不同风格的专属平台'
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
.func-title2 {
  font-size: 29px;
  text-align: center;
  font-weight: 600;
  color: #333333;
  padding-bottom: 56px;
}
</style>
